// Maison des Nus — OI PDP micro-behaviors. Mirrors OI's inline price-reveal + preloader reveal.
(function () {
  function reveal() {
    document.querySelectorAll('.product__price-wrapper').forEach(function (el) {
      el.style.opacity = '1';
    });
    document.querySelectorAll('.product__price-wrapper .installment').forEach(function (el) {
      el.style.display = 'block';
    });
    var pre = document.querySelector('.preloader-image + img');
    if (pre) pre.style.opacity = '1';
  }
  if (document.readyState === 'complete') {
    setTimeout(reveal, 1200);
  } else {
    window.addEventListener('load', function () { setTimeout(reveal, 1200); });
  }
})();
